import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('confirmationModal');

    return {
        BACK_BUTTON_TEXT: t('backButtonText')
    };
};

export default useTranslation;
